const SOUND_EVENT_TYPE = "ssml-sound-event";

export { SOUND_EVENT_TYPE };
//# sourceMappingURL=constant.js.map
